import { createFileRoute } from "@tanstack/react-router";
import { SubscriptionPage } from "../../features/billing/subscription-page";

export const Route = createFileRoute("/restaurants/$restaurantId_/subscription")({
	component: Page,
});

function Page() {
	const { restaurantId } = Route.useParams();
	return <SubscriptionPage key={restaurantId} restaurantId={restaurantId} />;
}
